@for (innslag of aksjeklassserMedAntallSortert; track innslag.navn){
  <div>
    {{innslag.navn}} ({{innslag.antall}})
  </div>
}
